angular.module('BookingApp')
.value 'CityTileSettings', {
  prependMilesText: '',
  customNightText: ''
}
